import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { LocalStorageService } from '../services/local.service';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.css'
})
export class AuthComponent implements OnInit, OnDestroy {
  isAuthenticated = false;
  authStatus = 'No Authenticated';
  profile: any;

  private readonly _destroying$ = new Subject<void>();

  constructor(
    private readonly oidcService: OidcSecurityService,
    private readonly servicoAuth: AuthService,
    private readonly route: Router,
    private readonly storage: LocalStorageService
  ) {}

  ngOnInit(): void {
    
    // Monitora mudanças de autenticação ao longo da sessão
    this.oidcService.isAuthenticated$
      .pipe(takeUntil(this._destroying$))
      .subscribe(({ isAuthenticated }) => {
        this.isAuthenticated = isAuthenticated;
        this.authStatus = isAuthenticated ? 'Authenticated' : 'No Authenticated';
      });
  }

  login() {
    this.servicoAuth.login();
  }

  logout() {
    console.log('Logout - via auth.components')
    this.servicoAuth.logout();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  handleError(error: any) {
    console.error('Authentication error:', error);
  }
}